// consent.ts - consentement cookies (CNIL) + chargement conditionnel de Google Analytics.
// Analytics n'est JAMAIS chargé avant un consentement explicite. Le choix est
// mémorisé en localStorage ; « Gérer les cookies » (footer) permet d'en changer.
import type { Analytics } from "firebase/analytics";
import { app } from "./firebase";

export type Consent = "granted" | "denied";

const STORAGE_KEY = "hr:analytics-consent";

let analytics: Analytics | null = null;

export function getStoredConsent(): Consent | null {
  try {
    const v = window.localStorage.getItem(STORAGE_KEY);
    return v === "granted" || v === "denied" ? v : null;
  } catch {
    return null; // localStorage indisponible (navigation privée stricte, etc.)
  }
}

export function storeConsent(value: Consent): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, value);
  } catch {
    // silencieux : sans stockage, le bandeau reviendra à la prochaine visite
  }
}

export function clearConsent(): void {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // silencieux
  }
}

/** Analytics est-il actif dans cette session ? */
export function isAnalyticsEnabled(): boolean {
  return analytics !== null;
}

/**
 * Charge Analytics (import dynamique : rien n'est téléchargé avant consentement).
 * getAnalytics envoie le page_view initial ; les navigations SPA (pushState) sont
 * comptées par l'« enhanced measurement » de GA4 - pas de page_view manuel ici.
 */
export async function enableAnalytics(): Promise<void> {
  if (analytics) return;
  try {
    const { getAnalytics, isSupported } = await import("firebase/analytics");
    if (await isSupported()) {
      analytics = getAnalytics(app);
    }
  } catch (err) {
    console.error("[landing] analytics init failed", err);
  }
}
